export const types = {
  CHANGE_ORGANIZATION_PERSONAS_EDIT_MODE: 'CHANGE_ORGANIZATION_PERSONAS_EDIT_MODE',
  SET_EDIT_FROM_ORGANIZATION_PERSONAS: 'SET_EDIT_FROM_ORGANIZATION_PERSONAS',
};
